/* Shopify adapter: customer-locale URLs, exact line identities, full cart after add. */
(() => {
  if(globalThis.DHCartAPI)return;
  class ShopifyAdapter {
    constructor(config){this.config=config;this.root=(config.root||'/').replace(/\/?$/,'/');}
    async request(path,body){
      if(['localhost','127.0.0.1','[::1]'].includes(location.hostname))throw new Error('Lokální náhled používá samostatný cart adapter.');
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),12000);
      try{
        const form=body instanceof FormData;
        const response=await fetch(this.root+path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(!form&&body?{'Content-Type':'application/json'}:{})},...(body?{body:form?body:JSON.stringify(body)}:{}),signal:controller.signal});
        const data=await response.json();
        if(!response.ok||data.status>=400)throw new Error(data.description||'Změnu košíku nelze potvrdit.');
        return data;
      }catch(e){if(e.name==='AbortError')throw new Error('Spojení trvá příliš dlouho. Přidání neopakujte, nejdříve ověřte košík.');throw e;}finally{clearTimeout(timer);}
    }
    async read(){
      const cart=await this.request('cart.js');
      let config=this.config,metadataWarning='';
      try{
        const response=await fetch(this.root+'?section_id=dh-cart-drawer',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(12000)});
        if(!response.ok)throw new Error('section');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        config=JSON.parse(doc.querySelector('[data-dh-cart-config]').textContent);
        this.config=config;
      }catch{
        metadataWarning='Podrobnosti produktů se nepodařilo obnovit. Ceny košíku jsou aktuální; předplatné nyní nelze měnit.';
        config={...config,catalog:(config.catalog||[]).map(p=>({...p,plans:[],variants:p.variants.map(v=>({...v,allocations:[]}))})),recommendations:[]};
      }
      const shipping=config.commerce?.enabled?config.commerce.shipping?.find(s=>s.country===config.country&&s.currency===cart.currency):null;
      return {cart,catalog:config.catalog||[],recommendations:config.recommendations||[],bump:config.bump,config,metadataWarning,concept:false,shipping};
    }
    add(payload){return this.request('cart/add.js',payload);}
    change(payload){return this.request('cart/change.js',payload);}
    checkout(){location.assign(this.root+'checkout');}
  }
  globalThis.DHCartAPI={ShopifyAdapter};
})();
